// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".commonExternalLogo_medium[data-v-7ca3b00e]{height:24px}.commonExternalLogo_large[data-v-7ca3b00e]{height:32px}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
